import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonTypeEnum} from '../../enums/skeleton';

export const SphereSkeleton: ISkeleton[] = [
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mb-xlg',
    style: 'width: 100%; height: 250px;'
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    classes: 'mb-xlg',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 300px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 300px;',
      }
    ]
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    classes: 'mb-xlg',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 300px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 300px;',
      }
    ]
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    classes: 'mb-xlg',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 300px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 300px;',
      }
    ]
  }
];
